import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';
import { ViewDashboard } from '../../Models/ViewDashboard'
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  public _DashboardService = environment.DashboardService;
  public _httpOptions;
  public sessionId : string = SessionID();
  //public _DashboardList: Dashboard[] = [];
  constructor(private http: HttpClient) {
    
    this.sessionId = sessionStorage["SessionId"]
    this._httpOptions = {
      headers: new HttpHeaders({ 'SessionId':this.sessionId })
    };
   }

  PageOnLoad(p_countryid: number): Observable<any> {
    

    var Query = this._DashboardService + '/' + p_countryid;
    console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }

  FetchAll() {
    

    // 15.all the datas should fetch in particular columns.based on country code
    var Query = this._DashboardService;
    console.log(Query);

    return this.http.get<{ data: any }>(Query,this._httpOptions).pipe(map(data => {
      const resultJSON = JSON.parse(JSON.stringify(data));
      console.log(resultJSON);        
      return data;
    }));
  }
}